import script from "./AvisoAppModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AvisoAppModal.vue?vue&type=script&lang=ts&setup=true"

import "./AvisoAppModal.vue?vue&type=style&index=0&id=72997031&scoped=true&lang=css"

import exportComponent from "/home/tecnonet/proyectos/galidancia_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72997031"]])

export default __exports__